import React from "react";
import { Award } from 'lucide-react';

const SecondaryCameraThanksPage = () => {
  return (
    <div className="min-h-screen app-background py-12 px-4 sm:px-6 lg:px-8 animate-gradient-x">
      <div className="max-w-4xl mx-auto">
        <div className="text-center my-16 animate-fade-in">
          <div className="flex justify-center mb-6">
            <Award className="w-20 h-20 text-yellow-400 animate-pulse" />
          </div>
          <h1 className="text-6xl font-semibold tracking-tight bg-gradient-to-r from-[#2960FD] to-[#FF60B6] text-transparent bg-clip-text mb-4">
            Thank You!
          </h1>
          <h3 className="text-2xl text-gray-200 mb-6">Your secondary camera session is complete.</h3>
          <p className="text-gray-400 text-lg">
            You can now close this screen.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecondaryCameraThanksPage;
